import { render, staticRenderFns } from "./employee-info-modal.component.vue?vue&type=template&id=5a6d7ed5&scoped=true&"
import script from "./employee-info-modal.component.vue?vue&type=script&lang=ts&"
export * from "./employee-info-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-info-modal.component.vue?vue&type=style&index=0&id=5a6d7ed5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d7ed5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
